import { render, staticRenderFns } from "./w-chat.vue?vue&type=template&id=0e9ddf27&"
import script from "./w-chat.vue?vue&type=script&lang=js&"
export * from "./w-chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports